import { USER_COOKIE_TOKEN_NAME } from 'constants/cookie';
import Cookies from 'js-cookie';

export const getAccessToken = () => Cookies.get(USER_COOKIE_TOKEN_NAME);
